<template>
  <div class="intelligent-main">
    <div class="intelligent-top">
      <div v-if="this.$i18n.locale === 'zh'" class="intelligent-top-text1">
        <span class="intelligent-top-span1">PrimeForce</span><br>
        <span class="intelligent-top-span2">SmartFeeding</span><br>
        <span class="intelligent-top-span2">智能进料辅助系统<span class="intelligent-top-span3">(选配)</span></span><br>

        <div style="height: 50px"></div>
        <span class="intelligent-top2-span1">自动过窗时可根据<span class="intelligent-top2-span2">所剩面料长度，</span>
        </span><br>
        <span class="intelligent-top2-span1">智能控制托布风机/传送桌板的<span
            class="intelligent-top2-span2">开启数量。</span>
      </span><br>
        <span class="intelligent-top2-span1">这台太势裁床无人看管，也可连续裁剪，</span><br>
        <span class="intelligent-top2-span1">聪明又节能，裁什么都给力。</span>
      </div>

      <div v-else class="intelligent-top-text1 intelligent-top-fedding">
        <span>PrimeForce <span style="font-size: var(--font-size-xl)">SmartFeeding</span> </span>
        <span style="font-size: var(--font-size-xl)">Assistance System</span>
        <span style="margin-bottom: 30px"> <span style="color: #4e95d9">Optional</span>  Smart Airflow & Conveyance Control</span>
        <span style="color: #808080">Adaptive Blower/Table Activation.</span>
        <span style="color: #808080">Dynamically adjusts based on remaining fabric length.</span>
        <span style="color: #808080">Unattended Operation.</span>
        <span style="color: #808080">Continuous cutting with zero supervision.</span>
        <span style="color: #808080">Energy-Saving Intelligence.</span>
        <span style="margin-bottom: 30px;color: #808080">Powers only necessarycomponents .</span>
        <span>Precision that never sleeps,</span>
        <span>cutting smarter while saving energy.</span>
      </div>
    </div>
    <div class="intelligent-bottom">
      <div class="intelligent-bottom-image1">
        <img class="intelligent-bottom1-image1" src="../../static/series/AdsorptionForce/fedding2.png" alt="">
        <img class="intelligent-bottom1-image3" src="../../static/series/AdsorptionForce/fedding3.png" alt="">
        <img class="intelligent-bottom1-image4" src="../../static/series/AdsorptionForce/fedding4.png" alt="">
        <img class="intelligent-bottom1-image2" src="../../static/series/AdsorptionForce/fedding1.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntelligentFedding',
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(['.intelligent-bottom1-image2'], {
        x: 700
      })
      this.$gsap.set(['.intelligent-bottom1-image1'], {
        x: 200
      })
      this.$gsap.set(['.intelligent-bottom1-image4'], {
        opacity: 0
      })
      this.$gsap.set(['.intelligent-bottom1-image4'], {
        x: '-15vw'
      })
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.intelligent-bottom',
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 1,
          toggleActions: 'play none none none',
          once: true
        }
      })

      // 字体进场
      masterTimeline.from('.intelligent-top-text1', {
        ease: 'power2.in',
        duration: 1.5,
        y: 100,
        opacity: 0
      })

      // 床身图片往左
      masterTimeline.to('.intelligent-bottom1-image2', {
        ease: 'power2.in',
        duration: 2,
        x: 400,
      }, 0.5)
      // 红色柱子往右
      masterTimeline.to('.intelligent-bottom1-image1', {
        ease: 'power2.in',
        duration: 2,
        x: 400,
      }, 0.5)
      // 左侧图片隐藏，显示另一张图片
      masterTimeline.to('.intelligent-bottom1-image3', {
        ease: 'power2.in',
        duration: 2,
        opacity: 0,
      }, 0.5)
      masterTimeline.to('.intelligent-bottom1-image4', {
        ease: 'power2.in',
        duration: 2,
        opacity: 1,
      }, 0.5)

    })
  }
}
</script>
<style scoped lang="css">
.intelligent-main {
  width: 100%;
  position: relative;
  margin-top: 200px;
}

.intelligent-top {
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 100px;
}

.intelligent-top-span1 {
  font-size: var(--font-size-lg);
}

.intelligent-top-span2 {
  font-size: var(--font-size-xl);
}

.intelligent-top-span3 {
  color: #808080;
  font-size: var(--font-size-lg);
}

.intelligent-top2-span1 {
  font-size: var(--font-size-lg);
  color: #808080;
}

.intelligent-top2-span2 {
  color: #4e95d9;
}

.intelligent-bottom {
  position: relative;
}

.intelligent-bottom-image1 {
  position: relative;
}

.intelligent-bottom1-image2 {
  position: relative;
  width: 100%;
  z-index: 2;
}

.intelligent-bottom1-image1 {
  position: absolute;
  top: 5.5vw;
}

.intelligent-bottom1-image3 {
  position: absolute;
  top: 9.5vw;
  width: 42%;
}

.intelligent-bottom1-image4 {
  position: absolute;
  top: 9.5vw;
  width: 42%;
}
.intelligent-top-fedding{
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-lg);
}
</style>
